import type { LearnedWord } from '@/services/api/users.api';
import type { VocabItem } from '@/types/vocabulary.types';

/**
 * Adapta una fila de `UserLearnedWord` al shape de {@link VocabItem} para reutilizar
 * `VocabularyFlashcard` / `VocabCard`.
 */
export function learnedWordToVocabItem(word: LearnedWord): VocabItem {
  return {
    id: word.id,
    word: word.word,
    partOfSpeech: word.partOfSpeech?.trim() || '—',
    ipa: '',
    translationEs: '',
    definitionEn: word.definition,
    exampleSentence: word.example?.trim() || '—',
    exampleTranslationEs: '',
    tags: [],
    relatedWords: [],
    wordAudioUrl: word.audioUrl ?? undefined,
  };
}
